module.exports = __webpack_public_path__ + "img/YM-LT.59a90a9c.png";